
import NrTooltip from '@nextrequestco/components/src/components/NrTooltip/NrTooltip.vue'
import truncate from 'lodash/truncate'
import helpers from '../../../utils/helpers.js'
import { mapState } from 'vuex'

interface LineItemOption {
  name: string
  cost: number
  quantity: number
  description: string
}

interface SurchargeOption {
  name: string
  amount: number
  cost_type: string // eslint-disable-line camelcase
  description: string
}

interface StaffHourOption {
  name: string
  hourly_rate: number // eslint-disable-line camelcase
  staff_cost: number // eslint-disable-line camelcase
  staff_hours: string // eslint-disable-line camelcase
}

export default {
  components: {
    NrTooltip
  },

  mounted() {
    this.calculateLineItems(this.lineItems)
    this.calculateStaffHours(this.staffHours)
  },

  computed: {
    ...mapState(['account', 'currentUser']),

    showInvoiceStaffName() {
      return this.account.show_invoice_staff_name
    }
  },

  methods: {
    truncate,

    setSurchargeName(surcharge: SurchargeOption): string {
      return surcharge.cost_type === 'percentage'
        ? `${surcharge?.name} (${surcharge?.amount}%)`
        : `${surcharge?.name}`
    },

    formatSurcharge(surcharge: SurchargeOption): number {
      const amount = surcharge?.amount
      return surcharge.cost_type === 'percentage'
        ? this.formatCost((amount / 100) * this.subtotalInvoiceAmount)
        : this.formatCost(Number(amount))
    },

    formatCost(cost: number, maximumFractionDigits: number = 2): string {
      return helpers.formatCost(cost, maximumFractionDigits)
    },

    calculateLineItems(lineItems: Array<LineItemOption>): void {
      lineItems.forEach((lineItem: LineItemOption) => {
        const cost = Number(lineItem.cost) * lineItem.quantity
        this.subtotalInvoiceAmount +=
          Math.round((cost + Number.EPSILON) * 100) / 100
      })
    },

    calculateStaffHours(staffHours: Array<StaffHourOption>): void {
      staffHours.forEach((hour: StaffHourOption) => {
        this.subtotalInvoiceAmount += Number(hour.staff_cost)
      })
    }
  },

  props: {
    totalAmount: {
      type: Number,
      default() {
        return 0
      }
    },
    lineItems: {
      type: Array,
      default() {
        return []
      }
    },
    surcharges: {
      type: Array,
      default() {
        return []
      }
    },
    staffHours: {
      type: Array,
      default() {
        return []
      }
    }
  },

  data() {
    return {
      subtotalInvoiceAmount: 0
    }
  }
}
